import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { useGetCatalogSongQuery } from '../../../../../../redux/api/fymAPI';
import type { CatalogItem } from '../../../../../../redux/api/fymAPI.types';
import { musicVideoFieldMessages as messages } from './musicVideoFieldMessages';
import { musicVideoFieldState } from './musicVideoFieldState';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song page; each part uses its own slice of it */
import styles from '../SongPage.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The music video chip in the head of Details (design music-video g1): "No music video" while the
 * song has none, "Music video ready" for a linked, uploaded or made video. Nothing while it is made.
 */
const SongMusicVideoChipComponent: React.FC<{ accountId: number; item: CatalogItem }> = ({ accountId, item }) => {
  const intl = useIntl();
  const { data } = useGetCatalogSongQuery({ accountId, itemUuid: item.uuid });
  const state = musicVideoFieldState(data?.song.musicVideo ?? item.musicVideo ?? null);
  if (state === 'none' || state === 'failed') {
    return (
      <span className={clsx(styles.chip, styles.off)} data-testid="music-video-chip">
        {intl.formatMessage(messages.chipNone)}
      </span>
    );
  }
  if (state === 'making') {
    return null;
  }
  return (
    <span className={clsx(styles.chip, styles.ok)} data-testid="music-video-chip">
      <i />
      {intl.formatMessage(messages.chipReady)}
    </span>
  );
};

export const SongMusicVideoChip = TypedMemo(SongMusicVideoChipComponent);
